// src/components/Card.js
import React from 'react'

export function Card({ as: Comp = 'section', className = '', children, ...props }) {
    return (
        <Comp className={`ui-card ${className}`} {...props}>
            {children}
        </Comp>
    )
}

export function CardHeader({ className = '', title, subtitle, children, ...props }) {
    return (
        <header className={`ui-card__header ${className}`} {...props}>
            {title ? <h3 className="ui-card__title">{title}</h3> : null}
            {subtitle ? <p className="ui-card__subtitle">{subtitle}</p> : null}
            {children}
        </header>
    )
}

export function CardBody({ className = '', children, ...props }) {
    return (
        <div className={`ui-card__body ${className}`} {...props}>
            {children}
        </div>
    )
}

export function CardFooter({ className = '', children, ...props }) {
    return (
        <footer className={`ui-card__footer ${className}`} {...props}>
            {children}
        </footer>
    )
}
